<template>
  <div>
    <el-dialog
        title="审核"
        :visible.sync="isShow"
        width="550px"
        :close-on-click-modal="false"
        :before-close="dialogBeforeClose"
    >
      <el-form
          ref="auditFormDom"
          hide-required-asterisk
          :model="auditForm"
          :rules="auditFormRules"
          :label-width="'100px'"
      >
        <el-form-item label="备注" prop="auditInfo">
          <el-input
              type="textarea"
              :rows="3"
              class="w350"
              v-model="auditForm.auditInfo"
              placeholder="请输入原因"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="footer-btns">
        <el-button type="primary" :loading="addbtnLoading" @click="handleFormAction(1)">通过</el-button>
        <el-button type="warning" :loading="addbtnLoading" @click="handleFormAction(2)">驳回补充材料</el-button>
        <el-button type="danger" :loading="addbtnLoading" @click="handleFormAction(3)">拒绝申请</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import record from '@/api/record'
import storage from '@/utils/storage'
import mixinAppConfig from "@/mixin/mixinAppConfig";


export default {
  mixins: [mixinAppConfig],
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    recordUuid: {
      type: String,
      required: true,
    },
    msgUuid: { // recordYouthToSquadUuid 或者 recordYouthUuid
      type: String,
      required: true,
    },
    recordType: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      userRole: storage.get('userInfo').userRole,
      auditForm: {
        auditInfo: "",
      },
      btnStatus: 1,
      addbtnLoading: false,
      allAmend: false,
    };
  },

  computed: {
    auditFormRules() {
      return {
        auditInfo: [
          {
            required: !![2, 3].includes(this.btnStatus),
            message: "如审核结果为驳回补充材料或拒绝申请，请输入具体原因。",
            trigger: ["blur", "change"],
          },
        ],
      };
    },

  },

  methods: {
    dialogBeforeClose() {
      this.setDialogStatus(false);
    },

    setDialogStatus(flag) {
      this.$emit("update:isShow", flag);
    },

    handleFormAction(stauts) {
      this.btnStatus = stauts;
      this.$nextTick(() => {
        this.$refs["auditFormDom"].validate((valid) => {
          if (valid) {
            this.addbtnLoading = true
            const {auditInfo} = this.auditForm;
            const postData = {
              auditInfo,
              auditState: stauts,
              recordUuid: this.recordUuid,
              recordType: this.recordType,
              auditType: 'manually',
            };
            if (this.recordType === "match") {
              postData.recordYouthToSquadUuid = this.msgUuid;
            }else {
              postData.recordYouthUuid = this.msgUuid;
            }

            record.recordAuditLogAdd(postData)
              .then((res) => {
                this.addbtnLoading = false
                if (res.code) {
                  this.$message.error(res.msg);
                  this.$emit('callback', false)
                  return;
                }
                this.setDialogStatus(false)
                this.$message.success("审核完成！");
                this.$emit('callback', true)
              })
              .catch((err) => {
                this.addbtnLoading = false
                this.$emit('callback', false)
                console.error("err", err);
              });
          }
        });
      });
    },


  },
};
</script>

<style lang="stylus" scoped>
.footer-btns
  width 60%
  margin 0 auto
  display flex
  justify-content space-around

.w350
  width 350px

.w300
  width: 340px

/deep/ .el-select-dropdown.is-multiple, /deep/ .el-select-dropdown__item.selected
  color $color_green
</style>
